import React, {Component} from 'react'
import {Link} from 'react-router';

class StationLinkCamera extends Component {
  handleClick(station) {
    this.props.onStationButtonCamera(station)
  }
  render() {
    const {station} = this.props
    const to = `/stations/${station.ID}/cameras`
    return <span>
      <Link to={to} onClick={() => this.handleClick(station)}>
        Camera
      </Link>
    </span>
  }
}

export default StationLinkCamera;



// WEBPACK FOOTER //
// ./src/components/StationLinkCamera.js